var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-section',{attrs:{"title":"HRV"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"section-pulse-content"},[_c('key-value-unit',{attrs:{"title":"SDNN","value":_vm.reportDetailModel.sdnn}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }